import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import settings from '../../config/settings';
import Footer from '../Footer/Footer';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Container, Grid, Typography } from '@material-ui/core';
import { useStyles } from './Styles';
import LogoAndBackground from '../Header/LogoAndBackground';
import DOMPurify from 'dompurify';
import { urlJoin } from 'url-join-ts';
import { useSharedStyles } from '../../sharedStyles/Styles';
import { Application, getApplication } from '../../api/application';
import { useAuthentication } from '../../Providers/AuthenticationProvider';
import { Spinner } from '@danfoss/webex-ui';

const SignupSuccess: React.FC = () => {
    const { t } = useTranslation();
    const sharedClasses = useSharedStyles();
    const classes = useStyles();
    const [application, setApplication] = useState<Application | null>(null);
    const { logoutWithRedirect } = useAuthentication();

    //Get querystring parameters
    const parsed = queryString.parse(globalThis.location.search);
    const client_id = DOMPurify.sanitize(parsed.client_id as string);
    const client_name = DOMPurify.sanitize(parsed.client_name as string);
    const ui_locale = DOMPurify.sanitize(parsed.ui_locales as string);
    const email = DOMPurify.sanitize(parsed.email as string);

    const emailSpan = `<span class=${classes.textRed}>${email}</span>`;

    useEffect(() => {

        // Set browser title
        document.title = t('login_signup.signup_confirm.browser_title');

        if (!sessionStorage.getItem("almost-there-visited") && !application) {
            sessionStorage.setItem("redirectAfterLogout", `/almost-there?client_id=${client_id}&client_name=${client_name}&ui_locales=${ui_locale}&email=${encodeURIComponent(email)}`);
            sessionStorage.setItem("almost-there-visited", "true");
            logoutWithRedirect();
        } else {
            sessionStorage.removeItem("almost-there-visited");

            const getApp = async () => {
                setApplication(await getApplication(client_id as string, ui_locale));
            }

            getApp();
        }        

    }, []);

    return !application ? (<Spinner visible={true}/>) : (
        <React.Fragment>
            <LogoAndBackground classes={sharedClasses} />
            <Container className={sharedClasses.containerRoot}>
                <Container maxWidth="md" className={`${sharedClasses.outerContainer} ${sharedClasses.relativeContainer}`}>
                    <Grid container className={sharedClasses.contentContainerRoot}>
                        <Grid item xs={12} className={classes.contentContainer}>
                            <Grid item xs={12}>
                                <Typography className={`${classes.mainTitle}`} data-testid='header-text'>
                                    {t('login_signup.signup_confirm.main_heading')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                {parse(t("login_signup.signup_confirm.body", { email: emailSpan }))}
                            </Grid>
                            <Grid container className={classes.linkContainer} spacing={2} >
                                <Grid item xs={12}>
                                    <a href={`${application.url}?&ui_locales=${ui_locale}`} className={classes.link} data-testid='continue-to-login-link'>
                                        <img src={urlJoin(settings.staticFiles.endpoint, '/images/system/LinkArrow.svg')} className={classes.linkArrow} alt="" /> {parse(t("login_signup.navigation.continue_to_login"))}
                                    </a>
                                </Grid>
                                <Grid item xs={12}>
                                    <a href={urlJoin(settings.application.url, `/verification?success=false&clientId=${client_id}&clientname=${client_name}&code=resend-email&message=resend-email&email=${encodeURIComponent(email)}&ui_locales=${ui_locale}`)} className={classes.link} data-testid='resend-verification-link'>
                                        <img src={urlJoin(settings.staticFiles.endpoint, '/images/system/LinkArrow.svg')} className={classes.linkArrow} alt="" /> {parse(t("login_signup.navigation.resend_verification_mail"))}
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </Container>
            <Footer contentClass={sharedClasses.footerContent} />
        </React.Fragment>
    );
}

export default SignupSuccess;
